<!--PROJETS-->
<ng-container *ngIf="installations">

<div class="container">
    <table class="table table-hover table-sm" id="projet">
        <thead>
            <th (click)="sortby('nom_installation')" scope="col" class="col-6">Nom</th>
            <th (click)="sortby('projet_commande_signee')" scope="col">BDC</th> 
            <th (click)="sortby('projet_status')" scope="col">Etat</th> 
            <th (click)="sortby('projet_mairie')" scope="col">Mairie</th> 
            <th (click)="sortby('date_installation')" scope="col">Install.</th> 
            <th (click)="sortby('adresse_code_postal')" scope="col">CP</th> 
            <th (click)="sortby('adresse_ville')" scope="col">Commune</th> 
            <th (click)="sortby('societe_proprietaire_raison_sociale')" scope="col">Société</th>
            <th (click)="sortby('projet_sens')" scope="col">D/G</th> 
            <th (click)="sortby('projet_kiosque')" scope="col">K</th> 
            <th (click)="sortby('projet_monnayeur')" scope="col">Monnaie</th> 
            <th (click)="sortby('projet_alim_elec')" scope="col">Alim.</th> 
            <th (click)="sortby('projet_remarque')" scope="col">Remarque</th>
        </thead>
        <tbody>
            <ng-container *ngFor="let installation of installations.projets">
            <tr [ngClass]="{
                'encours' : installation.projet_status == 'Travaux en cours',
                'enetude' : installation.projet_status == 'En étude',
                'pret' : installation.projet_status == 'Prêt pour installation',
                'enattente' : installation.projet_status == 'En attente',
                'abandonne' : installation.projet_status == 'Projet abandonné'
            }" (click)="onClickMachine(installation.id_installation)">
                <td >{{installation.nom_installation}}</td>
                <td>{{installation.projet_commande_signee}}</td>
                <td>{{installation.projet_status}}</td>
                <td>{{installation.projet_mairie}}</td>
                <td>{{installation.date_installation}}</td>
                <td>{{installation.adresse_code_postal}}</td>
                <td>{{installation.adresse_ville}}</td>
                <td>{{installation.societe_proprietaire_raison_sociale}}</td>
                <td>{{installation.projet_sens}}</td>
                <td>{{installation.projet_kiosque}}</td>
                <td>{{installation.projet_monnayeur}}</td>
                <td>{{installation.projet_alim_elec}}</td>
                <td>{{installation.projet_remarque}}</td>
            </tr>
        </ng-container> 
        </tbody>
    </table>
</div>

<!--Affichage par défaut : classé par date d'installation, de la plus proche à la plus éloignée
-->

<!-- <div class="mat-elevation-z8">
<mat-table [dataSource]="installations.projets">
    <ng-container matColumnDef="nom">
        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
        <mat-cell *matCellDef="let installation"> {{installation.nom_installation}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="bdc">
        <mat-header-cell *matHeaderCellDef> BDC </mat-header-cell>
        <mat-cell *matCellDef="let installation"> {{installation.projet_commande_signee}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="etat">
        <mat-header-cell *matHeaderCellDef> Etat </mat-header-cell>
        <mat-cell *matCellDef="let installation" >{{installation.projet_status}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="mairie">
        <mat-header-cell *matHeaderCellDef> Mairie </mat-header-cell>
        <mat-cell  *matCellDef="let installation" >{{installation.projet_mairie}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="install">
        <mat-header-cell *matHeaderCellDef> Install. </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.date_installation}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="cp">
        <mat-header-cell *matHeaderCellDef> CP </mat-header-cell>
        <mat-cell  *matCellDef="let installation">{{installation.adresse_code_postal}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="commune">
        <mat-header-cell *matHeaderCellDef> Commune </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.adresse_ville}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="societe">
        <mat-header-cell *matHeaderCellDef> Société </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.societe_proprietaire_raison_sociale}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dg">
        <mat-header-cell *matHeaderCellDef> D/G </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.projet_sens}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="k">
        <mat-header-cell *matHeaderCellDef> K </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.projet_kiosque}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="monnaie">
        <mat-header-cell *matHeaderCellDef> Monnaie </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.projet_monnayeur}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="alim">
        <mat-header-cell *matHeaderCellDef> Alim. </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.projet_alim_elec}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="remarque">
        <mat-header-cell *matHeaderCellDef> Remarque </mat-header-cell>
        <mat-cell  *matCellDef="let installation"> {{installation.projet_remarque}} </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['nom', 'bdc', 'etat', 'mairie', 'install', 'cp', 'commune', 'societe', 'dg', 'k', 'monnaie', 'alim', 'remarque'];"></mat-row>
</mat-table>
</div> -->




</ng-container>